import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import LOgo from '../assets/Ntact.png'
import api from '../api/api';
import { Backdrop, CircularProgress } from '@mui/material';
import { is } from 'date-fns/locale';
import { ShpPDFDocument } from './pdfs/shppdf';
import { useSelector } from 'react-redux';
const renderChecklistImages = (images,prefix,previewImage,setPreviewImage, ) => {
  // 👈 state for fullscreen image
  const filtered = images.filter((item) => item.question.startsWith(prefix));
  if (!filtered.length) return null;

  return (
    <>
      <div className="mt-4 mb-4">
        <div className="flex flex-wrap gap-4">
          {filtered.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col w-[180px] sm:w-[200px] p-3 border border-gray-300 rounded-lg shadow-sm bg-white"
              style={{ wordWrap: "break-word" }}
            >
              {/* Question */}
              <p className="font-semibold text-xs text-gray-800 mb-2 line-clamp-2">
                {item.question.replace(prefix + " ", "")}
              </p>

              {/* Multiple Images */}
              <div className="flex flex-wrap gap-2 justify-start">
                {item.urls && item.urls.length > 0 ? (
                  item.urls.map((url, i) => (
                    <img
                      key={i}
                      src={url}
                      alt={`${item.question}_${i}`}
                      onClick={() => setPreviewImage(url)} // 👈 open fullscreen
                      className="rounded-md border border-gray-300 cursor-pointer hover:opacity-80 transition"
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                  ))
                ) : (
                  <div className="w-full h-[60px] flex items-center justify-center bg-gray-100 text-gray-400 rounded-md border border-gray-200 text-xs">
                    No Image
                  </div>
                )}
              </div>

              {/* Comment */}
              <p className="text-xs text-gray-700 mt-2 break-words">
                <strong>Comment:</strong>{" "}
                {item.comment ? item.comment : "N/A"}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* 🔍 Fullscreen Image Preview Modal */}
      {previewImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setPreviewImage(null)}
        >
          <img
            src={previewImage}
            alt="Preview"
            className="max-w-full max-h-full rounded-lg shadow-lg"
          />
          <button
            onClick={() => setPreviewImage(null)}
            className="absolute top-4 right-4 bg-white/20 text-white text-lg font-bold px-3 py-1 rounded-full hover:bg-white/30 transition"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
};




const ViewSHPFormModal = ({ setFormView, rowData,handleSignOff, formType }) => {
  const formItems = rowData?.json_data || [];
  const pm_data = rowData?.pm_data || {}
  console.log(pm_data,'pmdata')
  const FormRef = useRef(null);
  const [imagesarray,setImagesArray]=useState({})
   const [previewImage, setPreviewImage] = useState(null);
   const [loader,setLoader]=useState(false)
const [uploadedimages,setuploadedimages]=useState([])
const[isloadingimages,setIsLoadingImages]=useState(false)
  const [selectedImage, setSelectedImage] = useState(null);
  const [safetyItemImages, setSafetyItemImages] = useState([]);
      const user = useSelector((state) => state.user.userDetails);
     const [signpreview,setSignPreview]=useState(null)
     const [signPreviews, setSignPreviews] = useState({});
     const isPdfLoading = loader || isloadingimages;

const observerName = Array.isArray(formItems)
  ? (formItems.find(item => 
        typeof item?.question === "string" && 
        item.question.includes("Auditor Signature")
    )?.answer ?? "N/A")
  : "N/A";
const signatureFiles = Array.isArray(formItems)
  ? (formItems.find(item => item?.question === "Signatures")?.answer ?? [])
  : [];
  const filledDate = rowData?.filled_date || "N/A";
const signatureDate = formItems?.find?.(
  item => item?.question?.includes?.("Signature Date")
)?.answer ?? "N/A";

const projectNumber = Array.isArray(formItems)
  ? (formItems.find(item =>
        typeof item?.question === "string" &&
        item.question.includes("Project Number")
    )?.answer ?? "N/A")
  : "N/A";
let pm_sign=rowData?.pm_sign
let pm_status=rowData?.pm_status
const pm_name=rowData?.pm_name
const location = Array.isArray(formItems)
  ? (formItems.find(item =>
        typeof item?.question === "string" &&
        item.question.includes("Location")
    )?.answer ?? "N/A")
  : "N/A";

const supervisorSignature = Array.isArray(formItems)
  ? (formItems.find(item =>
        typeof item?.question === "string" &&
        item.question.includes("Supervisor Signature")
    )?.answer ?? "N/A")
  : "N/A";

const fetchSignature = async (pmId) => {
  const cacheBuster = new Date().getTime();
  const signatureUrl = `https://hub2.ntactops.com/ntact/files/user_signatures/${pmId}_signature.png?cb=${cacheBuster}`;

  try {
    const response = await api.post("/v1/images/to-base64", {
      image_url: signatureUrl,
    });

    if (response.status === 200 && response.data?.base64) {
      const base64Image = `data:image/png;base64,${response.data.base64}`;

      setSignPreviews(prev => ({
        ...prev,
        [pmId]: base64Image
      }));
    }
  } catch (err) {
    console.log("No signature for PM:", pmId);
  }
};

  // Filter items into categories based on question prefixes
  const ppeItems = formItems.filter(item => item.question.startsWith("PPE"));
  const preJobPlanningItems = formItems.filter(item => item.question.startsWith("Pre-Job Planning"));
  const siteSafetyItems = formItems.filter(item => item.question.startsWith("Site Safety"));
  const workEnvironmentItems = formItems.filter(item => item.question.startsWith("Work Environment"));
  const workingAtHeightsItems = formItems.filter(item => item.question.startsWith("Working at Heights"));
  const toolsElectricalItems = formItems.filter(item => item.question.startsWith("Tools Electrical"));
  const weldingGasItems = formItems.filter(item => item.question.startsWith("Welding Gas"));
  const excavationItems = formItems.filter(item => item.question.startsWith("Excavation"));
  const subcontractorItems = formItems.filter(item => item.question.startsWith("Subcontractor"));
  const emergencyPlanItems = formItems.filter(item => item.question.startsWith("Emergency Plan"));
 const additionalnote = formItems.filter(item => item.question.startsWith("comment"));
 const commentImages = formItems.find(item => item.question === "commentImages")?.answer || [];
 const companylist =formItems.find(item => item.question === "companylist")?.answer || [];

const pmNameMap = {};
(companylist || []).forEach(item => {
  const id = item.projectManager?.pm_id;
  const name = item.projectManager?.pm_name;
  if (id) pmNameMap[id] = name;
});

  const infractions = formItems.find(item => item.question === "Infractions")?.answer || [];
// const filenamesArray = signatureFiles.map(file => file.file_name);
// const auditorsignatures=formItems.find(item => item.question === "Auditors")?.answer || []
// Collect all checklist groups
const checklistGroups = [
  ...ppeItems,
  ...preJobPlanningItems,
  ...siteSafetyItems,
  ...workEnvironmentItems,
  ...workingAtHeightsItems,
  ...toolsElectricalItems,
  ...weldingGasItems,
  ...excavationItems,
  ...subcontractorItems,
  ...emergencyPlanItems
];

// ✅ Filter only items having at least one image with a file_name
const itemsWithImages = checklistGroups.filter(
  item => Array.isArray(item.image) && item.image.some(img => img.file_name)
);
console.log(itemsWithImages, 'items');

// ✅ Fetch safety item images
// const fetchSafetyItemImages = async () => {
//   if (!itemsWithImages.length) return;

//   try {
//     setIsLoadingImages(true);

//     // Collect all filenames from all image arrays
//     const filenamesArray = itemsWithImages.flatMap(item =>
//       item.image
//         .filter(img => img.file_name)
//         .map(img => img.file_name)
//     );

//     const queryParams = filenamesArray
//       .map(name => `filenames=${encodeURIComponent(name)}`)
//       .join('&');

//     const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);

//     if (response.status === 200 && Array.isArray(response?.images)) {
//       // ✅ Build mapped array with all image URLs per checklist item
//       const mapped = itemsWithImages.map(item => {
//         const itemImages = item.image
//           .map(img => {
//             const imageObj = response.images.find(
//               rImg => rImg.filename === img.file_name
//             );
//             return imageObj ? imageObj.base64_data : null;
//           })
//           .filter(Boolean); // Remove nulls

//         return {
//           question: item.question,
//           comment: item.comment || "",
//           urls: itemImages // note plural now
//         };
//       });

//       setSafetyItemImages(mapped);
//     } else {
//       setSafetyItemImages([]);
//     }
//   } catch (error) {
//     console.error("Error fetching safety item images:", error);
//     setSafetyItemImages([]);
//   } finally {
//     setIsLoadingImages(false);
//   }
// };
const fetchSafetyItemImages = async () => {
  if (!itemsWithImages.length) return;

  try {
    setIsLoadingImages(true);

    // ❌ API CALL REMOVED
    // const response = await api.get(`/v1/documents/view-multiple?...`);

    const mapped = itemsWithImages.map(item => {
      const itemImages = item.image
        .filter(img => img.file_name)
        .map(img => {
          const originalUrl =
            `https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`;

          const proxyUrl =
            `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=` +
            encodeURIComponent(originalUrl);

          return proxyUrl;
        });

      return {
        question: item.question,
        comment: item.comment || "",
        urls: itemImages // same structure as before
      };
    });

    setSafetyItemImages(mapped);
  } catch (error) {
    console.error("Error building safety item image URLs:", error);
    setSafetyItemImages([]);
  } finally {
    setIsLoadingImages(false);
  }
};
    const fetchallImages = async () => {
  try {
    // Extract filenames
    const filenamesArray = infractions.map(infraction => infraction.photo.file_name);

    // Build query string
    const queryParams = filenamesArray
        .map(name => `filenames=${encodeURIComponent(name)}`)
        .join('&');

    console.log(queryParams);

    setIsLoadingImages(true);


    const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);
    if(response.status==200){
setuploadedimages(response?.images||[])
    }else{
     setuploadedimages([])
    }
    console.log(response.data);

  
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoadingImages(false);
  }

    
}

const checksignatureImage = async (userId) => {
  console.log("Checking signature for user:", userId);

  const cacheBuster = new Date().getTime();
  const signatureUrl = `https://hub2.ntactops.com/ntact/files/user_signatures/${userId}_signature.png?cb=${cacheBuster}`;

  try {
    // Convert the image URL to Base64 via API
    const response = await api.post("/v1/images/to-base64", {
      image_url: signatureUrl,
    });

    if (response.status === 200 && response.data?.base64) {
      const base64String = response.data.base64;

      // ✅ Create base64 data URL for <img>
      const base64Image = `data:image/png;base64,${base64String}`;

      setSignPreview(base64Image); // <-- this updates your state for <img src={signPreview} />
    } else {
      console.warn("Signature not found or invalid response:", response);
      setSignPreview(null);
    }
  } catch (error) {
    console.error("Error fetching signature:", error);
    setSignPreview(null);
  }
};
const fetchImages = async () => {
  try {
    setLoader(true);

    // const filenamesArray = signatureFiles.map(file => file.file_name);
   
    const auditorsignatures = formItems.find(item => item.question === "Auditors")?.answer || [];

    // collect both supervisor + auditor filenames
    const filenamesArray = [
      // ...signatureFiles.map(file => file.file_name),
      ...auditorsignatures.map(auditor => auditor.uploadedFile?.file_name)
    ].filter(Boolean); // removes any undefined filenames
     const queryParams = filenamesArray
      .map(name => `filenames=${encodeURIComponent(name)}`)
      .join('&');
    const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);

    if (response.status === 200) {
      

      // Map auditor names with the API response URLs
      const auditorUrls = auditorsignatures.map((auditor, index) => ({
        auditorName: auditor.auditorName,
        designation: auditor.designation,
        url: response?.images?.[index] || "" // assuming [0] is supervisor, next ones are auditors
      }));

      setImagesArray({
        // supervisorurl: { url: response?.images?.[0] },
        auditors: auditorUrls
      });
      console.log({
        supervisorurl: { url: response?.images?.[0] },
        auditors: auditorUrls
      },'urls')
    } else {
      setImagesArray([]);
    }

    console.log(response.data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoader(false);
  }
};

useEffect(() => {
  console.log(signatureFiles,'sigwnn')
fetchImages();
  if (infractions.length > 0) fetchallImages();
  if (itemsWithImages.length > 0) fetchSafetyItemImages();
}, []);

const generatePDF = async () => {
  if (isPdfLoading) return;

  try {
    setLoader(true);

    // Allow React + browser to render the loader first
    await new Promise(resolve => setTimeout(resolve, 50));

    const { pdf } = await import("@react-pdf/renderer");

    const blob = await pdf(
      <ShpPDFDocument
        companylist={companylist}
        imagesarray={imagesarray}
        observerName={observerName}
        filledDate={filledDate}
        safetyItemImages={safetyItemImages}
        signatureDate={signatureDate}
        projectNumber={projectNumber}
        location={location}
        supervisorSignature={supervisorSignature}
        empName={rowData?.emp_name || "N/A"}
        empId={rowData?.emp_id || "N/A"}
        jobDescription={rowData?.job_description || "N/A"}
        jobId={rowData?.job_id || "N/A"}
        ppeItems={ppeItems}
        preJobPlanningItems={preJobPlanningItems}
        siteSafetyItems={siteSafetyItems}
        workEnvironmentItems={workEnvironmentItems}
        workingAtHeightsItems={workingAtHeightsItems}
        toolsElectricalItems={toolsElectricalItems}
        weldingGasItems={weldingGasItems}
        excavationItems={excavationItems}
        subcontractorItems={subcontractorItems}
        emergencyPlanItems={emergencyPlanItems}
        infractions={infractions}
        uploadedimages={uploadedimages}
        additionalnote={additionalnote}
        commentImages={commentImages}
        pm_name={pm_name}
        pm_sign={pm_sign}
        pm_status={pm_status}
        signpreview={signpreview}
        pm_data={pm_data}
        signPreviews={signPreviews}
      />
    ).toBlob();

    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, "_blank");

  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    setLoader(false);
  }
};

  // const generatePDF = async () => {
  //   try {
  //      if (isPdfLoading) return; 
  //     const { pdf } = await import('@react-pdf/renderer');
  //      setLoader(true); // ✅ start loader
  //     const blob = await pdf(
  //       <ShpPDFDocument
  //       companylist={companylist}
  //       imagesarray={imagesarray}
  //         observerName={observerName}
  //         filledDate={filledDate}
  //         safetyItemImages={safetyItemImages}
  //         signatureDate={signatureDate}
  //         projectNumber={projectNumber}
  //         location={location}
  //         supervisorSignature={supervisorSignature}
  //         empName={rowData?.emp_name || "N/A"}
  //         empId={rowData?.emp_id || "N/A"}
  //         jobDescription={rowData?.job_description || "N/A"}
  //         jobId={rowData?.job_id || "N/A"}
  //         ppeItems={ppeItems}
  //         preJobPlanningItems={preJobPlanningItems}
  //         siteSafetyItems={siteSafetyItems}
  //         workEnvironmentItems={workEnvironmentItems}
  //         workingAtHeightsItems={workingAtHeightsItems}
  //         toolsElectricalItems={toolsElectricalItems}
  //         weldingGasItems={weldingGasItems}
  //         excavationItems={excavationItems}
  //         subcontractorItems={subcontractorItems}
  //         emergencyPlanItems={emergencyPlanItems}
  //         infractions={infractions}
  //         uploadedimages={uploadedimages}
  //         additionalnote={additionalnote}
  //             pm_name={pm_name}
  //           pm_sign={pm_sign}
  //           pm_status={pm_status}
  //           signpreview={signpreview}
          
  // pm_data={pm_data}
  // signPreviews={signPreviews}
  //       />
  //     ).toBlob();
  //     const pdfUrl = URL.createObjectURL(blob);
  //     window.open(pdfUrl, '_blank');
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //   }finally{
  //      setLoader(false);
  //   }
  // };

   useEffect(() => {
      if (FormRef.current) {
        FormRef.current.scrollTop = 0;
      }
    }, []);
  
    const handleBackdropClick = (e) => {
      // Check if the click target is the backdrop itself (not the modal content)
      if (e.target === e.currentTarget) {
        setFormView(false);
      }
    };
// useEffect(() => {
// console.log('extr',pm_status)

//   if (pm_status === 'Y' && pm_sign) {
//     // Extract number before underscore
//     const match = pm_sign.match(/^(\d+)_/);
//     if (match) {
//       const numberBeforeUnderscore = match[1];
//       console.log('Extracted number:', numberBeforeUnderscore);
      
//   checksignatureImage(numberBeforeUnderscore)
//       // You can use the extracted number here if needed
//     }
//   }
// ;
// }, [pm_status]);
useEffect(() => {
  if (!pm_data) return;

  Object.entries(pm_data).forEach(([pmId, status]) => {
    if (status === "Y") {
      fetchSignature(pmId);
    }
  });
}, [pm_data]);
  return (
    <div  onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 overflow-y-auto custom-scrollbar">
      <div className="relative w-full max-w-4xl flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
        <div className="w-full flex justify-between items-end">
        <button
            onClick={generatePDF}
            className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
          >
            Print
          </button>
          <button
            onClick={() => setFormView(false)}
            className="text-gray-600 hover:text-black"
          >
            <CloseIcon />
          </button>
        </div>

        <div ref={FormRef} className="w-[100%] mx-auto overflow-y-auto custom-scrollbar p-4">
          <div className="border-b border-gray-300 pb-2 mb-4">
            <div className='flex w-full justify-between'>
              <img src={NtactLogo} alt="NTACT Logo"/>
              <div>
                <h2 className="text-lg font-semibold">HEALTH SAFETY & ENVIRONMENTAL</h2>
              </div>
              <div className='mr-24'></div>
            </div>
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm font-semibold text-left mt-2">
                  Document Name:<br/>SAFETY AND HEALTH PRIMARY AUDIT FORM
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-left">
                  Section: <br/>HSE-18
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold">Revision: 2</p>
                <p className="text-sm font-semibold">Document Number: 18-5-D</p>
              </div>
            </div>
          </div>

          {/* Modal Header */}
          <div className="flex items-center justify-center w-full border-b border-gray-300 pb-2 mb-4">
            <h2 className="text-lg font-bold">SAFETY AND HEALTH PRIMARY AUDIT FORM</h2>
          </div>

          {/* Observer and Date Info */}
          <div className="grid grid-cols-2 gap-4 mb-4">
           {imagesarray?.auditors?.length > 0 && imagesarray.auditors.map((auditor, index) => (
  <div key={index} className="border border-[#9CA3AF] p-1 mb-2 rounded">
    <p className="text-sm font-inter font-semibold text-left">Auditor Name:</p>
    <p className="text-left font-inter p-1 px-2">{auditor.auditorName || 'N/A'}</p>
    <hr className="border-t border-[#9CA3AF]" />

    <p className="text-sm font-inter font-semibold text-left mt-2">Designation:</p>
    <p className="text-left font-inter p-1 px-2">{auditor.designation || 'N/A'}</p>
    <hr className="border-t border-[#9CA3AF]" />

    <p className="text-sm font-inter font-semibold text-left mt-2">Signature:</p>
    <div className="p-2 flex justify-start">
      {auditor.url ? (
        <img
          src={auditor?.url?.base64_data}
          alt={`${auditor.auditorName}'s signature`}
          className="w-32 h-16 object-contain border border-gray-300 rounded"
        />
      ) : (
        <p className="text-gray-500 italic">No signature available</p>
      )}
    </div>
  </div>
))}

            <div className='border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Date of Audit:</p>
              <p className="text-left font-inter p-1 px-2">{filledDate}</p>
              <hr className="border-t border-[#9CA3AF]"/>
            </div>
       

          </div>
          
        <div className="grid grid-cols-3 gap-4 mb-4">
  {companylist?.[0]?.company?.name && (
    <div className='border border-[#9CA3AF] p-1'>
      <p className="text-sm font-inter font-semibold text-left">Company:</p>
      <p className="text-left font-inter p-1 px-2">
        {companylist[0].company.name}
      </p>
      <hr className="border-t border-[#9CA3AF]"/>
    </div>
  )}
  {/* EXISTING EMPLOYEE */}
  <div className='border border-[#9CA3AF] p-1'>
    <p className="text-sm font-inter font-semibold text-left">Employee:</p>
    <p className="text-left font-inter p-1 px-2">
      {rowData?.emp_name} ({rowData?.emp_id})
    </p>
    <hr className="border-t border-[#9CA3AF]"/>
  </div>

  {/* EXISTING JOB */}
  <div className='border border-[#9CA3AF] p-1'>
    <p className="text-sm font-inter font-semibold text-left">Job:</p>
    <p className="text-left font-inter p-1 px-2">
      {rowData?.job_description} #{rowData?.job_id}
    </p>
    <hr className="border-t border-[#9CA3AF]"/>
  </div>

  {/* COMPANY from array[0] */}


 

</div>
{companylist.slice(1).map((item, idx) => (
  <div key={idx} className="grid grid-cols-3 gap-4 mb-4">

    {/* COMPANY */}
    <div className='border border-[#9CA3AF] p-1'>
      <p className="text-sm font-inter font-semibold text-left">Company:</p>
      <p className="text-left font-inter p-1 px-2">
        {item?.company?.name}
      </p>
      <hr className="border-t border-[#9CA3AF]"/>
    </div>

    {/* EMPLOYEE */}
    <div className='border border-[#9CA3AF] p-1'>
      <p className="text-sm font-inter font-semibold text-left">Employee:</p>
      <p className="text-left font-inter p-1 px-2">
        {item?.employee?.emp_name} ({item?.employee?.emp_id})
      </p>
      <hr className="border-t border-[#9CA3AF]"/>
    </div>

    {/* JOB */}
    <div className='border border-[#9CA3AF] p-1'>
      <p className="text-sm font-inter font-semibold text-left">Job:</p>
      <p className="text-left font-inter p-1 px-2">
       #{item?.job?.job_num}
      </p>
      <hr className="border-t border-[#9CA3AF]"/>
    </div>

  </div>
))}


          {/* Section 1: PPE */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 1: PPE (Personal Protective Equipment)</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {ppeItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("PPE - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`ppe-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                  
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`ppe-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`ppe-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "PPE -",previewImage,setPreviewImage,)}
          {/* Section 2: Pre-Job Planning */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 2: Pre-Job Planning & Training</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {preJobPlanningItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Pre-Job Planning - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`prejob-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`prejob-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`prejob-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Pre-Job Planning -",previewImage,setPreviewImage)}
          {/* Section 3: Site Safety */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 3: Site Safety</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {siteSafetyItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Site Safety - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`sitesafety-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`sitesafety-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`sitesafety-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Site Safety -",previewImage,setPreviewImage)}
          {/* Section 4: Work Environment */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 4: Work Environment</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {workEnvironmentItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Work Environment - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workenv-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workenv-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                  
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workenv-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Work Environment -",previewImage,setPreviewImage)}
          {/* Section 5: Working at Heights */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 5: Working at Heights</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {workingAtHeightsItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Working at Heights - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workingheights-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workingheights-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`workingheights-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Working at Heights -",previewImage,setPreviewImage)}
          {/* Section 6: Tools Electrical */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 6: Tools Electrical</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {toolsElectricalItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Tools Electrical - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`toolselectrical-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`toolselectrical-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`toolselectrical-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Tools Electrical -",previewImage,setPreviewImage)}
          {/* Section 7: Welding Gas */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 7: Welding Gas</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {weldingGasItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Welding Gas - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`weldinggas-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`weldinggas-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                    
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`weldinggas-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Welding Gas -",previewImage,setPreviewImage)}
          {/* Section 8: Excavation */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 8: Excavation</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {excavationItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Excavation - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`excavation-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
urez                    name={`excavation-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                  
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`excavation-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Excavation -",previewImage,setPreviewImage)}
          {/* Section 9: Subcontractor */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 9: Subcontractor Safety</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {subcontractorItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Subcontractor - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`subcontractor-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                    
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`subcontractor-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                  
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`subcontractor-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                    
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Subcontractor -",previewImage,setPreviewImage)}
          {/* Section 10: Emergency Action Plan */}
          <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">SECTION 10: Emergency Action Plan</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="col-span-2 p-1">Item Description</div>
              <div className="p-1">YES</div>
              <div className="p-1">NO</div>
              <div className="p-1">N/A</div>
            </div>
            {emergencyPlanItems.map((item, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="col-span-2 p-1 text-left font-inter">{item.question.replace("Emergency Plan - ", "")}</div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`emergency-${index}`}
                    value="YES"
                    checked={item.answer === "YES"}
                  
                    className="accent-green-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`emergency-${index}`}
                    value="NO"
                    checked={item.answer === "NO"}
                  
                    className="accent-red-600"
                  />
                </div>
                <div className="text-center p-1">
                  <input
                    type="radio"
                    name={`emergency-${index}`}
                    value="N/A"
                    checked={item.answer === "N/A"}
                  
                    className="accent-gray-600"
                  />
                </div>
              </div>
            ))}
          </div>
{renderChecklistImages(safetyItemImages, "Emergency Plan -",previewImage,setPreviewImage)}
          {/* Details of Infractions */}
          {/* <div className="mb-4 border border-gray-300">
            <p className="text-sm font-inter font-semibold text-left bg-gray-200 p-2 border-b border-gray-300">Details of Infractions / Notes</p>
            <div className="grid grid-cols-5 text-center text-sm font-semibold border-b border-gray-300 bg-gray-100">
              <div className="p-1">Section</div>
              <div className="p-1">Item</div>
              <div className="p-1">Corrective Action</div>
              <div className="p-1 col-span-2">Completed (Y/N)</div>
            </div>
            {infractions.map((infraction, index) => (
              <div key={index} className="grid grid-cols-5 items-center text-sm border-b border-gray-300">
                <div className="p-1 text-center font-inter">{infraction.section}</div>
                <div className="p-1 text-center font-inter">{infraction.item}</div>
                <div className="p-1 text-center font-inter">{infraction.correctiveAction}</div>
                <div className="text-center p-1 col-span-2 flex justify-center space-x-2">
                  <input
                    type="radio"
                    name={`infraction-${index}`}
                    value="Y"
                    checked={infraction.completed === "Y"}
                  
                    className="accent-green-600"
                  />
                  <span>Y</span>
                  <input
                    type="radio"
                    name={`infraction-${index}`}
                    value="N"
                    checked={infraction.completed === "N"}
                    
                    className="accent-red-600"
                  />
                  <span>N</span>
                </div>
              </div>
            ))}
          </div> */}
          <div>
{/* 
<div className="my-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
  {uploadedimages?.map((image, index) => {

    const relatedInfraction = infractions.find(
      (infraction) => infraction.photo?.file_name === image.filename
    );

    return image?.base64_data ? (
      <div key={index}    className="flex flex-col items-center cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:-translate-y-1"
              onClick={() => setSelectedImage(image.base64_data)}>
        <img
          src={image.base64_data}
          alt={`Auditor Signature ${index + 1}`}
          className="w-full max-w-xs h-32 object-contain border border-gray-300 rounded-md shadow-sm bg-white"
        />
    
        {relatedInfraction && (
          <span className="mt-1 text-sm  font-medium text-gray-700">
            {relatedInfraction.section}
          </span>
        )}
      </div>
    ) : null;
  })}
</div> */}
          </div>
{additionalnote?.[0]?.answer ? (
  <div
    className="text-start text-sm p-3 rounded-md mb-2 border border-gray-300 bg-gray-50 mt-3 shadow-sm"
    style={{ lineHeight: "1.4" }}
  >
    <p className="font-semibold text-gray-800 mb-1">
       Additional Comments
    </p>
    <p className="text-gray-700 whitespace-pre-wrap">
      {additionalnote[0].answer}
    </p>
  </div>
) : null}

{/* Comment Images */}
{commentImages?.length > 0 && (
  <div className="mt-3 mb-2 border border-gray-300 bg-gray-50 rounded-md p-3 shadow-sm">
    <p className="font-semibold text-gray-800 mb-2 text-sm text-left">Comment Images</p>
    <div className="flex flex-wrap gap-3">
      {commentImages.map((img, i) => {
        const fileName = typeof img === 'string' ? img : (img?.file_name || img?.fileName || img?.name || '');
        const imageUrl = fileName
          ? `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
              `https://hub2.ntactops.com/ntact/files/forms_files/${fileName}`
            )}`
          : (img?.file_path || img?.url || img?.uri || '');
        return imageUrl ? (
          <img
            key={i}
            src={imageUrl}
            alt={`Comment ${i + 1}`}
            className="w-32 h-32 object-cover border border-gray-300 rounded-md cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => setSelectedImage(imageUrl)}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : null;
      })}
    </div>
  </div>
)}

          {/* Signatures */}
         <div className="grid grid-cols-2 gap-4">


  {/* Project Manager Signature */}
  {/* <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Supervisor :</p>
    <hr className="border-t border-[#9CA3AF]" />

    {imagesarray?.supervisorurl?.url?.base64_data && (
      <img
        src={imagesarray?.supervisorurl?.url?.base64_data}
        alt="Project Manager Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
    )}

    <p className="text-sm font-inter font-semibold text-left mt-2">Date:</p>
    <p className="text-left font-inter p-1 px-2">{signatureDate}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div> */}
          {/* {signpreview ? (
  <div className="grid grid-cols-1 gap-4">

    <div className="border border-[#9CA3AF] p-1">
      <p className="text-sm font-inter font-semibold text-left">
        Signed By: Project Manager
      </p>
      <p className="text-left font-inter p-1 px-2">{pm_name}</p>
      <hr className="border-t border-[#9CA3AF]" />

      <p className="text-sm font-inter font-semibold text-left mt-2">
        Signature:
      </p>
      <img
        src={signpreview}
        alt="Project Manager Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
      <hr className="border-t border-[#9CA3AF]" />
    </div>

  
  </div>
) : (
  <><div className="grid grid-cols-1 gap-4">

  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">
    Project Manager
    </p>
      <hr className="border-t border-[#9CA3AF] mt-5" />
    <p className="text-left font-inter p-1 px-2">{pm_name}</p>
    <hr className="border-t border-[#9CA3AF]" />



   {user.role === 3? <div className="flex flex-col items-start item-center justify-center gap-5 mt-2 px-2">
      <p className="text-xs text-start text-gray-600 font-inter mb-1">
        Please click below to sign off and confirm project completion.
      </p>
      <button
        className="bg-[#2563EB] text-white font-inter text-sm px-4 py-2 rounded-md shadow-md hover:bg-[#1E40AF] transition-all"
        onClick={()=>handleSignOff(rowData)}
      >
        Sign Off
      </button>
    </div>:<> <p className="text-xs text-gray-500 italic mt-2 px-2 font-inter">
        Awaiting project manager sign-off...
      </p></>}

  
  </div>
</div>
</>
)} */}
<div className="grid grid-cols-1 gap-4">
 <div className="grid grid-cols-1 gap-4">
  {Object.entries(pm_data || {}).map(([pmId, status]) => {
    const preview = signPreviews[pmId];
    const pmName = pmNameMap[pmId] || "Project Manager";

    const isCurrentPM = Number(pmId) === Number(user.id);
    const canSign = user.role === 3 && isCurrentPM && status !== "Y";

    return (
      <div key={pmId} className="border border-[#9CA3AF] p-2">

        {/* NAME */}
        <p className="text-sm font-semibold">
          Project Manager
        </p>
        <hr className="mt-2 mb-2"/>

        <p className="px-2">{pmName}</p>
        <hr className="mt-2 mb-2"/>

        {/* SIGNED */}
        {status === "Y" && preview ? (
          <>
            <p className="text-sm font-semibold mt-2">Signature:</p>
            <img
              src={preview}
              className="w-40 h-24 object-contain border rounded mt-2"
            />
          </>
        ) : (
          <>
            {canSign ? (
              <div className="flex flex-col gap-3 mt-3 px-2">
                <p className="text-xs text-gray-600">
                  Please click below to sign off and confirm project completion.
                </p>

                <button
                  className="bg-[#2563EB] text-white text-sm px-4 py-2 rounded-md hover:bg-[#1E40AF]"
                  onClick={() => handleSignOff(rowData,pmId)}
                >
                  Sign Off
                </button>
              </div>
            ) : (
              <p className="text-xs text-gray-500 italic mt-2 px-2">
                Awaiting project manager sign-off...
              </p>
            )}
          </>
        )}

      </div>
    );
  })}
</div>

</div>

</div>

        </div>
      </div>
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Full View"
            className="max-w-full max-h-full object-contain rounded-md"
          />
          <button
            className="absolute top-5 right-5 text-white text-2xl font-bold"
            onClick={() => setSelectedImage(null)}
          >
            &times;
          </button>
        </div>
      )}
       <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loader||isloadingimages}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
    </div>
  );
};

export default ViewSHPFormModal;